import { useState } from 'react';

export default function HeroSection() {
  const [searchValue, setSearchValue] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchValue.trim()) {
      window.REACT_APP_NAVIGATE(`/?search=${encodeURIComponent(searchValue.trim())}`);
    }
  };

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20creative%20workspace%20with%20organized%20bookshelves%2C%20modern%20desk%20with%20laptop%2C%20soft%20natural%20sunlight%20streaming%20through%20windows%2C%20cream%20and%20warm%20beige%20walls%2C%20indoor%20plants%2C%20cozy%20atmosphere%2C%20editorial%20style%2C%20clean%20aesthetic%2C%20high%20detail%2C%20warm%20ambient%20tones&width=1800&height=1000&seq=hero-laoliu-2024&orientation=landscape"
          alt="老六资源库 - 海量资源一站式获取平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto animate-fade-in-up">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/15 backdrop-blur-sm rounded-full mb-6 border border-white/20">
            <i className="ri-sparkling-line text-white/90 text-sm"></i>
            <span className="text-xs md:text-sm text-white/90 font-medium whitespace-nowrap">
              已收录 11,200+ 优质资源，持续更新中
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 font-heading leading-tight">
            老六资源库
          </h1>
          <p className="text-base md:text-xl text-white/80 mb-4 max-w-xl mx-auto leading-relaxed">
            海量资源一站式获取平台
          </p>
          <p className="text-sm md:text-base text-white/60 mb-8 max-w-lg mx-auto leading-relaxed">
            涵盖学习资料、工具软件、影音素材等优质内容，告别繁琐搜索，高效找到所需资源
          </p>

          <form onSubmit={handleSearch} className="max-w-lg mx-auto flex items-center gap-0 bg-white rounded-full overflow-hidden shadow-lg shadow-black/10">
            <div className="flex items-center pl-5">
              <i className="ri-search-line text-lg text-foreground-400"></i>
            </div>
            <input
              type="text"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder="搜索你需要的资源..."
              className="flex-1 px-3 py-4 text-sm text-foreground-800 placeholder-foreground-400 bg-transparent outline-none border-none"
            />
            <button
              type="submit"
              className="px-6 py-4 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium transition-colors whitespace-nowrap cursor-pointer rounded-full m-1"
            >
              搜资源
            </button>
          </form>

          <div className="flex flex-wrap items-center justify-center gap-3 mt-6">
            {['学习资料', '工具软件', '影音素材', '设计资源'].map((tag) => (
              <span
                key={tag}
                className="px-4 py-1.5 bg-white/10 backdrop-blur-sm rounded-full text-xs md:text-sm text-white/80 border border-white/15 hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap"
                onClick={() => setSearchValue(tag)}
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}